/**
 * Eventos de conclusão do Embedded Signup do WhatsApp.
 *
 * O fluxo de coexistência devolve um evento próprio. Ou seja: o modo não é
 * escolhido na entrada, é a Meta que informa na saída o que de fato aconteceu —
 * o usuário pode entrar pelo fluxo padrão e concluir em coexistência, se a
 * opção estiver habilitada na conta. Por isso o `coexistence` enviado ao
 * backend sai daqui, e não do `mode` da querystring.
 *
 * Módulo separado de `whatsappSignup.ts` porque aquele lê `import.meta.env`
 * (Vite), que o jest do frontend não consegue parsear.
 */
export const SIGNUP_FINISH_PADRAO = 'FINISH';
export const SIGNUP_FINISH_COEXISTENCIA = 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING';

export const ehEventoConclusao = (evento?: string): boolean =>
    evento === SIGNUP_FINISH_PADRAO || evento === SIGNUP_FINISH_COEXISTENCIA;
